import script from "./PopapBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./PopapBlock.vue?vue&type=script&setup=true&lang=js"

import "./PopapBlock.vue?vue&type=style&index=0&id=dda733e4&lang=scss"

const __exports__ = script;

export default __exports__